export default (cityName?: string, countryName?: string) =>
  `${cityName && cityName !== 'null' ? cityName : ''}${
    cityName && cityName !== 'null' && countryName && countryName !== 'null'
      ? ', '
      : ''
  }${countryName && countryName !== 'null' ? countryName : ''}`;
